<template>
  <b-modal
    ref="modal-warranty-bill-excel"
    hide-footer
    :title="titleExcel"
    id="modal-warranty-bill-excel"
    @shown="getHistoryExportExcel()"
  >
    <b-row class="mb-4">
      <b-col cols="12">
        <b-form-group label="Danh sách cần xuất:">
          <b-form-radio-group v-model="selectedListExcel">
            <b-form-radio :value="WARRANTY_BILL_EXPORT_MODE.ALL"
              >Tất cả các trang</b-form-radio
            >
            <b-form-radio :value="WARRANTY_BILL_EXPORT_MODE.FILTER"
              >Theo bộ lọc</b-form-radio
            >
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        v-if="selectedListExcel === WARRANTY_BILL_EXPORT_MODE.FILTER"
      >
        <p class="text-muted font-italic mb-0">
          Xuất đúng theo bộ lọc đang áp dụng ở danh sách.
        </p>
      </b-col>
      <b-col cols="12">
        <b-row v-if="selectedListExcel === WARRANTY_BILL_EXPORT_MODE.ALL">
          <b-col md="4">
            <b-form-group>
              <label>Từ ngày:</label>
              <date-picker
                placeholder="Từ ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="exportDates.fromDate"
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Đến ngày:</label>
              <date-picker
                placeholder="Tới ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="exportDates.toDate"
              ></date-picker>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <div>
      <hr
        class="hr-text"
        data-content="Lịch sử xuất excel"
        style="font-weight: 600"
      />
      <b-table
        class="myTable"
        caption-top
        responsive
        bordered
        hover
        :fields="fieldHistory"
        :items="histories"
      >
        <template v-slot:cell(actions)="row">
          <v-icon
            v-if="
              +row.item.processingStatus === PROCESSING_DOWNLOAD_STATUS.COMPLETED
            "
            small
            class="text-primary"
            title="Tải xuống"
            v-b-tooltip
            @click="downloadExcel(row.item.id)"
            >mdi-download</v-icon
          >
          <div
            v-else-if="
              +row.item.processingStatus ===
              PROCESSING_DOWNLOAD_STATUS.PROCESSING
            "
            class="d-flex align-items-center"
          >
            <b-progress height="20px" class="flex-grow-1">
              <b-progress-bar
                :value="row.item.process"
                :label="`${row.item.process}%`"
                animated
                variant="success"
              ></b-progress-bar>
            </b-progress>
            <v-icon
              small
              class="text-danger ml-2"
              title="Dừng tải xuống"
              v-b-tooltip
              :disabled="isSubmitting('cancel-' + row.item.id)"
              @click="cancelDownload(row.item.id)"
              >mdi-close</v-icon
            >
          </div>
          <div v-else class="d-flex align-items-center justify-content-center">
            <span class="text-danger">Xuất file thất bại</span>
            <v-icon
              small
              class="text-danger ml-2"
              title="Xoá khỏi danh sách"
              v-b-tooltip
              :disabled="isSubmitting('cancel-' + row.item.id)"
              @click="cancelDownload(row.item.id)"
              >mdi-close</v-icon
            >
          </div>
        </template>
      </b-table>
    </div>

    <SaveButton
      class="mr-3"
      :button-style="{
        fontWeight: '600',
        minWidth: '70px',
        whiteSpace: 'nowrap',
      }"
      :is-busy="isExporting"
      @click="exportToExcelStream"
    >
      <v-icon
        small
        class="text-white"
        v-b-tooltip
      >mdi-download</v-icon>
      <strong>Xuất Excel</strong>
    </SaveButton>

    <b-button
      style="width: 80px"
      variant="secondary"
      size="sm"
      :disabled="isSubmitting('export')"
      @click="$bvModal.hide('modal-warranty-bill-excel')"
    >
      <strong>Hủy</strong>
    </b-button>
  </b-modal>
</template>

<style scoped>
div /deep/ .modal-backdrop {
  opacity: 0.5;
}
</style>

<script>
import { validationMixin } from 'vuelidate';
import { checkPermissions } from '@/utils/saveDataToLocal';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import {
  MODULE_TYPE,
  PROCESSING_DOWNLOAD_STATUS,
  WARRANTY_BILL_EXPORT_LIMIT,
  WARRANTY_BILL_EXPORT_MODE,
} from '@/utils/enum';
import ApiService from '@/core/services/api.service';
import fileDownload from '@/utils/file-download';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from 'moment';
import timeUtils from '@/utils/date';
import SaveButton from '@/view/components/common/SaveButton.vue';
import submitLock from '@/view/mixins/submit-lock.mixins';

export default {
  props: ['param', 'mode', 'totalRow'],
  mixins: [validationMixin, submitLock],
  data() {
    return {
      PROCESSING_DOWNLOAD_STATUS,
      WARRANTY_BILL_EXPORT_MODE,
      dpConfigs: null,
      selectedListExcel: WARRANTY_BILL_EXPORT_MODE.ALL,
      apiParams: null,
      //  Khoảng ngày riêng của mode "Tất cả các trang", không ghi đè khoảng ngày của lưới.
      exportDates: { fromDate: null, toDate: null },
      titleExcel: 'Xuất excel hoá đơn bảo hành',
      types: [],
      selectedMisa: false,
      histories: [],
      pollingIntervals: {},
      fieldHistory: [
        {
          key: 'name',
          label: 'Tên File',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '80%' },
          tdClass: 'text-center',
        },
        { key: 'actions', label: '', tdClass: 'text-center' },
      ],
    };
  },
  beforeDestroy() {
    this.stopPolling();
  },
  created() {
    this.dpConfigs = timeUtils.DP_CONFIG;
  },
  components: {
    datePicker,
    SaveButton,
  },
  watch: {
    $props: {
      handler() {
        switch (this.mode) {
          case 5:
            this.titleExcel = 'Xuất excel hoá đơn bảo hành';
            break;
          default:
            this.titleExcel = 'Không xác định';
            break;
        }
        this.apiParams = { ...this.param };
        //  mở modal lần nào cũng lấy lại khoảng ngày đang lọc ở lưới làm mặc định
        this.exportDates = {
          fromDate: this.apiParams.fromDate,
          toDate: this.apiParams.toDate,
        };
      },
      deep: true,
      immediate: true,
    },
  },
  validations: {},
  computed: {
    //  Request trả về gần như tức thì nên khoá thêm theo bản ghi nào chưa đạt 100%.
    isExporting() {
      return (
        this.isSubmitting('export') ||
        this.histories.some(
          (item) =>
            +item.processingStatus === PROCESSING_DOWNLOAD_STATUS.PROCESSING,
        )
      );
    },
  },
  methods: {
    checkPermissions,
    exportToExcelStream() {
      return this.withSubmitLock('export', () => this.doExportToExcelStream());
    },
    async doExportToExcelStream() {
      const apiParams = this.getParamFilters();

      if (!apiParams) {
        return;
      }

      try {
        //  Ghi file chạy nền, response chỉ báo đã nhận. Tải lại ở bảng lịch sử bên dưới.
        const { data } = await ApiService.query('bills/export-warranty-excel', {
          params: apiParams,
        });
        makeToastSuccess(data.message);
      } catch (err) {
        makeToastFaile(await this.getErrorMessage(err));
      } finally {
        this.$nprogress.done();
        //  await để khoá giữ tới khi histories có dòng mới, tránh nút mở lại quá sớm.
        await this.getHistoryExportExcel();
      }
    },
    async getHistoryExportExcel() {
      try {
        //  moduleType để lịch sử của màn này không lẫn với các màn xuất excel khác
        const { data } = await ApiService.query('bills/history-export-excel', {
          params: { moduleType: MODULE_TYPE.WARRANTY_BILL },
        });

        if (!data.status) {
          return;
        }

        this.histories = await Promise.all(
          data.data
            .filter((item) => item.url)
            .map(async (item) => {
              let process = 100;

              if (
                +item.processingStatus === PROCESSING_DOWNLOAD_STATUS.PROCESSING
              ) {
                const progress = await this.getProcessDownload(item.id);
                process = progress ? progress.process : 0;
                this.startPolling(item.id);
              }

              return { ...item, name: item.url.split('/').pop(), process };
            }),
        );
      } catch (err) {
        makeToastFaile(await this.getErrorMessage(err));
      }
    },
    async downloadExcel(id) {
      try {
        const response = await ApiService.query(
          `bills/download-excel?id=${id}`,
          { responseType: 'blob' },
        );
        fileDownload.createFile(
          response.data,
          fileDownload.getFileName(response),
        );
      } catch (err) {
        makeToastFaile(await this.getErrorMessage(err));
      } finally {
        this.getHistoryExportExcel();
      }
    },
    cancelDownload(id) {
      return this.withSubmitLock(`cancel-${id}`, () =>
        this.doCancelDownload(id),
      );
    },
    async doCancelDownload(id) {
      try {
        const { data } = await ApiService.delete(
          `bills/cancel-process-excel?id=${id}`,
        );

        //  ApiService.delete tự nuốt lỗi (api.service.js:179-190), trả về error object nên phải kiểm `data &&`, không thì TypeError rơi xuống catch và toast đè câu lỗi đúng.
        if (data && data.status) {
          makeToastSuccess(data.message);
        }
      } catch (err) {
        makeToastFaile(await this.getErrorMessage(err));
      } finally {
        this.stopPolling(id);
        this.getHistoryExportExcel();
      }
    },
    async getProcessDownload(id) {
      try {
        const { data } = await ApiService.get(`bills/process-excel?id=${id}`);

        return data.data;
      } catch (err) {
        return null;
      }
    },
    startPolling(id) {
      if (this.pollingIntervals[id]) {
        return;
      }

      this.pollingIntervals[id] = setInterval(async () => {
        const progress = await this.getProcessDownload(id);

        if (!progress) {
          return this.stopPolling(id);
        }

        this.histories = this.histories.map((item) =>
          item.id === id ? { ...item, process: progress.process } : item,
        );

        if (+progress.process === 100) {
          this.stopPolling(id);
          this.getHistoryExportExcel();
        }
      }, 5000);
    },
    //  Không truyền id thì dọn toàn bộ - dùng khi component bị huỷ.
    stopPolling(id) {
      const ids = id ? [id] : Object.keys(this.pollingIntervals);

      ids.forEach((key) => {
        clearInterval(this.pollingIntervals[key]);
        delete this.pollingIntervals[key];
      });
    },
    async getErrorMessage(err) {
      if (!err.response) {
        // network error
        return 'Lỗi!';
      }

      const data = err.response.data;
      // request blob thì body lỗi cũng là Blob, phải đọc text rồi parse mới ra message
      if (data instanceof Blob) {
        try {
          const { message } = JSON.parse(await data.text());
          return message || 'Lỗi!';
        } catch (parseError) {
          return 'Lỗi!';
        }
      }

      return data.message || 'Lỗi!';
    },
    getValuesMultiSelect(arr, prop) {
      return arr.reduce((accumulator, currentValue) => {
        if (currentValue.checked) accumulator.push(currentValue[prop]);
        return accumulator;
      }, []);
    },
    getParamFilters() {
      const DATE_FORMAT = 'DD/MM/YYYY';
      const DATE_DB_FORMAT = 'YYYY-MM-DD';
      const dateSource =
        this.selectedListExcel === WARRANTY_BILL_EXPORT_MODE.FILTER
          ? this.apiParams
          : this.exportDates;

      const fromDate = dateSource.fromDate
        ? moment(dateSource.fromDate, DATE_FORMAT).format(DATE_DB_FORMAT)
        : moment().subtract(7, 'd').format('YYYY-MM-DD');

      const toDate = dateSource.toDate
        ? moment(dateSource.toDate, DATE_FORMAT).format(DATE_DB_FORMAT)
        : moment().format('YYYY-MM-DD');

      const warrantyReasonId = this.apiParams.warrantyReasonId || null;

      const billStatus = this.apiParams.status || null;
      const storeIds = this.apiParams.storeIds || null;

      const apiParams = {
        exportMode: this.selectedListExcel,
        fromDate: fromDate,
        toDate: toDate,
        warrantyReasonId: warrantyReasonId,
        status: billStatus,
        storeIds: storeIds,
      };
      if (this.selectedListExcel === WARRANTY_BILL_EXPORT_MODE.FILTER) {
        const totalRow = Number(this.totalRow) || 0;
        if (totalRow > WARRANTY_BILL_EXPORT_LIMIT.MAX_ROWS) {
          makeToastFaile(
            `Chỉ được xuất tối đa ${WARRANTY_BILL_EXPORT_LIMIT.MAX_ROWS} dòng mỗi lần. Vui lòng thu hẹp bộ lọc!`,
          );
          return null;
        }

        apiParams.id = this.apiParams.id || null;
        apiParams.customer = this.apiParams.customer || null;
        apiParams.searchProduct = this.apiParams.searchProduct || null;
        apiParams.searchIMEI = this.apiParams.searchIMEI || null;
        apiParams.saleId = this.apiParams.saleId || null;
        apiParams.companyId = this.apiParams.companyId || null;

        // chế độ này không giới hạn khoảng thời gian, đổi lại chặn bằng số dòng ở trên
        return apiParams;
      }

      const diff = this.getDaysDiff(apiParams.fromDate, apiParams.toDate);
      if (diff > WARRANTY_BILL_EXPORT_LIMIT.MAX_RANGE_DAYS) {
        makeToastFaile('Vui lòng chọn khoảng thời gian trong vòng 1 tháng!');
        return null;
      }

      return apiParams;
    },
    getDaysDiff(startDate, endDate, dateFormat = 'YYYY-MM-DD') {
      const getDateAsArray = (date) => {
        return moment(date.split(/\D+/), dateFormat);
      };
      return (
        getDateAsArray(endDate).diff(getDateAsArray(startDate), 'days') + 1
      );
    },
  },
};
</script>
